import {GoogleMap, useJsApiLoader} from '@react-google-maps/api'
import {latLng} from '../../util'
import {googleMapsLoaderOptions} from '../../../utils/googleMapsLoader'

type PropsContextMenu = {
  latLng: latLng
  onClickMap?: any
  children?: React.ReactChild
}

export const GoogleMaps: React.FC<PropsContextMenu> = ({latLng, onClickMap, children}) => {
  const {isLoaded, loadError} = useJsApiLoader(googleMapsLoaderOptions)

  const containerStyle = {
    height: '400px',
  }

  const center = latLng.lat ?  {
    lat: latLng.lat,
    lng: latLng.lng
  } :  {
    lat: -23.56834983242366,
    lng: -46.65739491734664,
  }

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>
  }

  if (!isLoaded || typeof google === 'undefined') {
    return <div>Carregando mapa...</div>
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={18}
      onClick={onClickMap}
    >
      {children}
    </GoogleMap>
  )
}
